<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="md"
    :modal-title="`대량 연장 결과`"
    :close="close"
    name="excelExtendResultModal"
  >
    <b-container>
      <b-row>
        <b-col>
          <b-form-floating-label>
            대량 연장 결과 (성공)
          </b-form-floating-label>
          <div class="result-container">
            <div v-for="(success, index) in successResult" :key="index" class="result">
              {{`${success.manageCode} 권한만료일 ${getDate(success.expiredAt)}`}}
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-floating-label>
            대량 연장 결과 (실패)
          </b-form-floating-label>
          <div class="result-container">
            <div v-for="(fail, index) in failResult" :key="index" class="result">
              {{`${fail.manageCode}`}}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>
<script>
import customDate from "@/util/custom-date"
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "ExcelExtendResultModal",
  components: {AdminModal},
  props: ['isOpen', 'successResult', 'failResult', 'close'],
  methods: {
    getDate(date) {
      return customDate.stringFormat(date)
    },
  }
}
</script>
<style scoped>
  .result-container {
    max-height: 100px;
    overflow-y: auto;
    border: 1px solid #444;
    border-radius: 5px;
    padding: 5px;
  }
</style>